module.exports = __webpack_public_path__ + "static/media/img_feature_photo1@3x.511a8d85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_feature_photo1@3x.jpg
// module id = 791
// module chunks = 0